import { AppSettings } from 'src/app/services/AppSettings';
import { TimezoneDatePipe } from 'src/app/timezone-date.pipe';

/**
 * The per-record massaging the /notifications page applies after fetching
 * `notification/find`, extracted so the header slider feeds the shared
 * message template the same data the page does:
 *  - `notifyTime` is rendered through TimezoneDatePipe (the message copy for
 *    Stripe failures, for example, prints it), and
 *  - a relative `notifyData.logo` path is prefixed with the photo base URL.
 *
 * Mutates and returns the record, exactly like the page did inline.
 */
export function prepareNotificationForDisplay(ele: any): any {
  if (!ele) return ele;
  const timezoneDatePipe = new TimezoneDatePipe();
  ele.notifyTime = timezoneDatePipe.transform(ele.notifyTime);
  if (ele.notifyData != null) {
    const logo = ele?.notifyData?.logo;
    if (logo) {
      if (!(logo.startsWith('http://') || logo.startsWith('https://'))) {
        ele.notifyData.logo = AppSettings.photoUrl + logo;
      }
    }
    // Some business notifications (e.g. BUSINESS_EMPLOYEE_REVOKE) send the logo as businessLogo.
    const businessLogo = ele?.notifyData?.businessLogo;
    if (businessLogo && typeof businessLogo === 'string') {
      if (!(businessLogo.startsWith('http://') || businessLogo.startsWith('https://'))) {
        ele.notifyData.businessLogo = AppSettings.photoUrl + businessLogo;
      }
    }
  }
  return ele;
}
